import styled from '@emotion/styled';

import _InputIcon from '@/assets/icons/icon_input.svg';
import _MailIcon from '@/assets/icons/icon_mail.svg';
import _MailDoneIcon from '@/assets/icons/icon_mail_done.svg';
import StepArrowIcon from '@/assets/icons/icon_step_arrow.svg';
import _UploadIcon from '@/assets/icons/icon_upload.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
    backgroundColor: defaultTheme.background.white,
    padding: [defaultTheme.spacing.l, defaultTheme.spacing.l, '32px'],
  }),
);

export const StepList = styled.ol(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(3, 1fr)',
      'repeat(3, 1fr)',
    ],
    gridColumnGap: '32px',
    marginBottom: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const Step = styled.li((props: { stepNum: number; done?: boolean }) =>
  mq({
    display: 'flex',
    flexDirection: ['row', 'row', 'column'],
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: props.done
      ? defaultTheme.color.grayScale.medium
      : defaultTheme.text.default,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: [defaultTheme.spacing.s, defaultTheme.spacing.s, 0, 0],
    borderBottom: [
      `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      'none',
      'none',
    ],
    '&:before': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      content: `"${props.stepNum}"`,
      width: ['32px', '32px', '48px', '48px'],
      height: ['32px', '32px', '48px', '48px'],
      color: defaultTheme.text.white,
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.s,
        defaultTheme.font.size.xl,
        defaultTheme.font.size.xl,
      ],
      borderRadius: defaultTheme.border.radius.circle,
      backgroundColor: props.done
        ? defaultTheme.background.mediumGray
        : defaultTheme.background.primary,
      margin: [0, 0, '0 auto', '0 auto'],
    },
  }),
);

const IconCss = {
  display: 'block',
  width: ['80px', '80px', '152px', '152px'],
  height: ['80px', '80px', '152px', '152px'],
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
};

export const MailIcon = styled.i((props: { isDone: boolean }) =>
  mq({
    ...IconCss,
    backgroundImage: `url(${props.isDone ? _MailDoneIcon : _MailIcon})`,
  }),
);

export const InputIcon = styled.i(() =>
  mq({
    ...IconCss,
    backgroundImage: `url(${_InputIcon})`,
  }),
);

export const UploadIcon = styled.i(() =>
  mq({
    ...IconCss,
    backgroundImage: `url(${_UploadIcon})`,
  }),
);

export const ArrowIcon = styled.i(() =>
  mq({
    display: 'block',
    width: '80px',
    height: '43px',
    backgroundImage: `url(${StepArrowIcon})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    margin: '0 auto',
  }),
);

export const StepTextContainer = styled.p(() =>
  mq({
    textAlign: 'center',
    fontWeight: 'bold',
    margin: [
      `${defaultTheme.spacing.l} 0 0`,
      `${defaultTheme.spacing.l} 0 0`,
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
    ],
  }),
);

export const RegisterCompleteSpan = styled.span(() =>
  mq({
    display: 'block',
    fontSize: defaultTheme.font.size.l,
    marginBottom: '32px',
  }),
);

export const AnchorButtonContainer = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '320px',
    margin: [
      `${defaultTheme.spacing.m} auto 0`,
      `${defaultTheme.spacing.m} auto 0`,
      `${defaultTheme.spacing.l} auto 0`,
      `${defaultTheme.spacing.l} auto 0`,
    ],
  }),
);

export const NoticeTextContainer = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'center',
    marginTop: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
    span: {
      fontWeight: 'bold',
    },
  }),
);
